/* eslint-disable import/order */
import { MenuIdSettings } from '@jira/navigation-apps__constants/src/MenuIdSettings.tsx';
import { SidebarIdGlobalSystemSettings } from '@jira/navigation-apps__constants/src/SidebarIdGlobalSystemSettings.tsx';
import { LazyAtlassianNavigation } from '@jira/navigation-apps__atlassian-navigation/src/async.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { navigationSidebarGlobalResource } from '@jira/router-resources__navigation-sidebar-global/src/navigationSidebarGlobalResource.tsx';
import { getNavigationResources } from '@jira/router-resources__navigation/src/getNavigationResources.tsx';
import { externalImportRoute } from '@jira/router-routes__admin-pages-external-import-routes/src/externalImportRoute.tsx';
import { conditionalPostOfficeJiraTopBannerResource } from '@jira/router-resources__post-office/src/conditionalPostOfficeJiraTopBannerResource.tsx';
import type { Route } from '@atlassian/react-resource-router';
import ExternalImport from './ui/async.tsx';

export const externalImportRouteEntry: Route = createEntry(externalImportRoute, () => ({
	group: 'global-settings',
	// eslint-disable-next-line no-restricted-syntax
	component: ExternalImport,

	navigation: {
		sidebarId: SidebarIdGlobalSystemSettings,
		menuId: MenuIdSettings,
	},

	resources: [
		...getNavigationResources(),
		navigationSidebarGlobalResource,
		conditionalPostOfficeJiraTopBannerResource,
	],

	forPaint: [LazyAtlassianNavigation],

	bifrost: {
		bifrostGroup: 'shell-only',
	},
}));
